import { autoColor } from "../lib/teamBadge";

/* ───────────────────── COLOR PICKER ─────────────────────
   value = "" means "auto from team name"; a hex means a custom pick. */
export function ColorPicker({ value, onChange, teamName }) {
  const custom = !!value;
  const effective = value || autoColor(teamName);
  return (
    <div className="flex items-center gap-2">
      <label className="flex items-center gap-1.5 text-xs text-gray-500 cursor-pointer">
        <input
          type="checkbox"
          checked={custom}
          onChange={(e) => onChange(e.target.checked ? effective : "")}
        />
        Custom
      </label>
      <input
        type="color"
        value={effective}
        disabled={!custom}
        onChange={(e) => onChange(e.target.value)}
        className="w-8 h-8 rounded border border-gray-200 p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        title={custom ? "Custom color" : "Check 'Custom' to override"}
      />
      <span className="w-6 h-6 rounded-full border border-gray-200 flex-shrink-0" style={{ backgroundColor: effective }} />
      {!custom && <span className="text-[10px] text-gray-400">auto from name</span>}
    </div>
  );
}
